var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeakEntity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 80,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    stroke: "#000",
    x: 4.5,
    y: 7,
    width: 147,
    height: 67,
    id: "svg_1"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    stroke: "#000",
    x: 10,
    y: 12,
    width: 137,
    height: 57,
    id: "svg_8"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    stroke: "#000",
    x: 17,
    y: 49,
    id: "svg_6",
    strokeWidth: 0,
    fontSize: 24,
    fontFamily: "Noto Sans JP",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "Weak Entity"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeakEntity);
export default __webpack_public_path__ + "static/media/WeakEntity.59037f0c7afc948b49443e1dd5942835.svg";
export { ForwardRef as ReactComponent };